import { shape, string, number } from 'prop-types';

export default shape({
    category: shape({
        id: number,
        name: string,
        level: number,
    }),
    topSale: shape({
        id: number.isRequired,
    }),
    brand: shape({
        id: number.isRequired,
        name: string.isRequired,
    }),
});
